module.exports = __webpack_public_path__ + "assets/14cfda6fdb4986813ad7e3ed994c99a7.mp4";